import { Entry } from 'contentful'
import { TypeBaseModalWithoutUnresolvableLinksResponse } from '@/contentful-types'

type HasBaseModal = {
  baseModal?: Entry<any>
}

type MappedModal = {
  id: TypeBaseModalWithoutUnresolvableLinksResponse['sys']['id']
  entryTitle: TypeBaseModalWithoutUnresolvableLinksResponse['fields']['entryTitle']
  heading: TypeBaseModalWithoutUnresolvableLinksResponse['fields']['heading']
  subHeading: TypeBaseModalWithoutUnresolvableLinksResponse['fields']['subHeading']
  components: TypeBaseModalWithoutUnresolvableLinksResponse['fields']['components']
  modalMaxWidth: TypeBaseModalWithoutUnresolvableLinksResponse['fields']['modalMaxWidth']
  disableAnalytics: TypeBaseModalWithoutUnresolvableLinksResponse['fields']['disableAnalytics']
}

export const mapModal = (props: { fields: any; sys: any; metadata: any }): MappedModal => {
  const fields = props?.fields as HasBaseModal
  if (!fields?.baseModal?.fields) return null

  const modalFields = fields.baseModal.fields as TypeBaseModalWithoutUnresolvableLinksResponse['fields']

  return {
    id: fields.baseModal?.sys?.id,
    entryTitle: modalFields?.entryTitle,
    heading: modalFields?.heading,
    subHeading: modalFields?.subHeading,
    components: modalFields?.components,
    modalMaxWidth: modalFields?.modalMaxWidth,
    disableAnalytics: modalFields?.disableAnalytics,
  }
}
